import { render, staticRenderFns } from "./RoomMappingClientLogs.vue?vue&type=template&id=7843b955&scoped=true"
import script from "./RoomMappingClientLogs.vue?vue&type=script&lang=js"
export * from "./RoomMappingClientLogs.vue?vue&type=script&lang=js"
import style0 from "./RoomMappingClientLogs.vue?vue&type=style&index=0&id=7843b955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7843b955",
  null
  
)

export default component.exports